import { Box, Icon, IconOptions, SvgIconOptions, Text, TextNew } from '@jfs/ui-new'
import { Container } from '../../../comps/Container'
// import { Box, ButtonNew, Icon, SearchBar, Spacer, SpacerNew, Tab, TextNew } from '@jfs/ui-new'
import { SvgIcons } from '@jfs/ui-new/src/comps/Icon'

export const displayNameToSvgId: Record<string, SvgIconOptions> = {
  'NCMC Recharge': 'mobile_recharge_icon',
  'Mobile Recharge': 'mobile_recharge_icon',
  FASTag: 'fastag_icon',
  Electricity: 'electricity_icon',
  DTH: 'dth_icon',
  'Book LPG': 'book_lpg_icon',
  'Credit Card Bill Payment': 'credit_card_icon',
  Fiber: 'fiber_icon',
  'Mobile Postpaid': 'mobile_postpaid_icon',
  Water: 'water_icon_icon',
  Landline: 'landline_icon_icon',
  'Piped Gas': 'piped_gas_icon',
  Broadband: 'broadbank_icon_icon',
  'Cable TV': 'cable_tv_icon',
  'Loan Payment': 'loan_payment_icon',
  'Recurring Deposit': 'recurring_deposite_icon',
  Insurance: 'insurance_icon',
  'Municipal Tax': 'municiple_tax_icon',
  Rent: 'rent_icon_icon',
  'Housing Society': 'housing_society_icon',
  Subscription: 'subscription_icon',
  'Club & Association': 'club_and_association_icon',
  'Hospital & Pathology': 'hospital_path_icon',
  'Education Fee': 'education_fee_icon',

  Charity: 'rent_icon_icon',
  'Housing Society Payments': 'housing_society_icon',
  'Subscription Payments': 'subscription_icon',
  'Hospital and Pathology Payments': 'hospital_path_icon',
  'Clubs and Associations Payments': 'club_and_association_icon',
  'B2B Electronics': 'rent_icon_icon',

  'Postpaid Mobile Payments': 'mobile_postpaid_icon',
  'Electricity Payments': 'electricity_icon',
  'LPG Booking': 'book_lpg_icon',
  'Gas Payments': 'piped_gas_icon',
  'Water Payments': 'water_icon_icon',

  'Insurance Payments': 'insurance_icon',
  'Loan Repayment': 'loan_payment_icon',
  'Tax Payments': 'municiple_tax_icon',
  'Credit Card Payments': 'credit_card_icon',
  'Recurring Deposits': 'recurring_deposite_icon',
  Rentals: 'rent_icon_icon',

  'DTH Payments': 'dth_icon',
  'Broadband Payments': 'broadbank_icon_icon',
  'Landline Payments': 'landline_icon_icon',
  'Cable TV Payments': 'cable_tv_icon',
}

const DEFAULT_ICON_ID_SVG: SvgIconOptions = 'rent_icon_icon'
const DEFAULT_ICON_ID_FONT: IconOptions = 'INFO'

export const CategoryGrid = ({
  data,
  svgMap,
  onPress,
}: {
  data: any[]
  svgMap: Record<string, SvgIconOptions>
  onPress: (categoryId: number) => void | Promise<void>
}) => (
  <Box flexDirection={'row'} justifyContent={'flex-start'} flexWrap={'wrap'}>
    {data.map((category) => {
      const finalIconKey = svgMap[category.displayName] || DEFAULT_ICON_ID_SVG
      const isSvgAvailable = !!SvgIcons[finalIconKey]
      return (
        <Box
          key={category.id}
          paddingY={10}
          flexDirection={'column'}
          alignItems={'center'}
          width={'25%'}
          onPress={() => onPress(category.id)}>
          <Icon
            id={isSvgAvailable ? 'INFO' : DEFAULT_ICON_ID_FONT}
            svgId={isSvgAvailable ? finalIconKey : undefined}
            size={34}
            color={'BRAND_PRIMARY_GREEN'}
          />
          <Box mt={8}>
            <Text fontSize={12} textAlign="center">
              {category.displayName}
            </Text>
          </Box>
        </Box>
      )
    })}
  </Box>
)